import { buildApiUrl } from '../config/environment';

// API service for miscellaneous API calls
export const apiService = {
  // Handle Stripe subscription
  handleSubscribe: async (priceId: string): Promise<{ success: boolean; error?: string }> => {
    try {
      // Request stripe publishable key and create checkout session
      const checkoutResponse = await fetch(buildApiUrl('/api/subscription/create-checkout-session'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ priceId })
      });

      if (checkoutResponse.ok) {
        const { sessionId, publishableKey } = await checkoutResponse.json();
        
        // Dynamically load Stripe
        const { loadStripe } = await import('@stripe/stripe-js');
        const stripe = await loadStripe(publishableKey);
        
        if (stripe) {
          // Redirect to Stripe Checkout
          const { error } = await stripe.redirectToCheckout({ sessionId });
          if (error) {
            return { success: false, error: error.message };
          }
          return { success: true };
        } else {
          return { success: false, error: 'Failed to load Stripe' };
        }
      } else {
        const errorData = await checkoutResponse.json();
        return { success: false, error: errorData.error || 'Failed to create checkout session' };
      }
    } catch (error) {
      console.error('Subscription error:', error);
      return { success: false, error: 'Subscription failed' };
    }
  },

  // Generic utility to load Stripe (kept for potential other uses)
  loadStripe: async (publishableKey: string) => {
    const { loadStripe } = await import('@stripe/stripe-js');
    return loadStripe(publishableKey);
  }
};